module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/pathways-hero-570c823f33e4560b41c409ad3ac8cf63.svg";